import { useEffect, useCallback, useContext } from 'react';
import { useMsal } from '@azure/msal-react';
import { AuthenticationContext } from './AuthenticationProvider';
import { useAuthentication } from './authenticationUtilities';
import { useAppSelector } from 'reducers/hooks';
import { selectIsAuthenticated } from 'reducers/userSlice';

function AuthenticationCallbackPage() {
  const { instance } = useMsal();
  const setAuthorization = useAuthentication();
  const authenticationContext = useContext(AuthenticationContext);
  const isAuthenticated = useAppSelector(selectIsAuthenticated);

  const handleRedirect = useCallback(async () => {
    try {
      // Wait for MSAL to complete redirect token parsing
      const response = await instance.handleRedirectPromise();

      if (response) {
        // User just logged in via redirect; MSAL stores account automatically
        setAuthorization(authenticationContext.authConfig, true);
      } else if (!isAuthenticated) {
        // Fallback: attempt silent token if already authenticated
        await setAuthorization(authenticationContext.authConfig, true);
      }
    } catch (error) {
      console.error('MSAL redirect handling error:', error);
    }
  }, [instance, authenticationContext, setAuthorization, isAuthenticated]);

  useEffect(() => {
    handleRedirect();
  }, [handleRedirect]);

  return <></>;
}

export default AuthenticationCallbackPage;
